const colorFunctions = {
    hexToRgb: hex => {
        const validHex = /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
        if (!validHex) {
            return null;
        }
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgb(${r}, ${g}, ${b})`;
    },
    hexToRgba: (hex, a) => {
        const validHex = /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
        if (!validHex) {
            return null;
        }
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        if (a < 0 || a > 1) {
            return null;
        }
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
};

export default colorFunctions;
